// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container {
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.nav-menu .tippy-box {
  margin: 0 !important;
  background-color: #FDFDFD !important;
}
.nav-menu .tippy-box .tippy-arrow {
  color: #FDFDFD !important;
}
.nav-menu .tippy-box .tippy-content {
  padding: 0 !important;
  width: 220px !important;
}

.city-selector .dropdown-selector {
  height: 44px !important;
  padding: 12px !important;
}

.navbar-button {
  height: 44px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 16.1px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/style.scss"],"names":[],"mappings":"AAAA;EAEE,mCAAA;UAAA,2BAAA;AAAF;;AAIE;EACE,oBAAA;EACA,oCAAA;AADJ;AAEI;EACE,yBAAA;AAAN;AAEI;EACE,qBAAA;EACA,uBAAA;AAAN;;AAME;EACE,uBAAA;EACA,wBAAA;AAHJ;;AAOA;EACE,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;AAJF","sourcesContent":[".navbar-container {\n  // border-bottom: 1px solid theme('colors.grey-10');\n  backdrop-filter: blur(10px);\n}\n\n.nav-menu{  \n  .tippy-box {\n    margin: 0 !important;\n    background-color: #FDFDFD !important;\n    .tippy-arrow{\n      color:#FDFDFD !important;\n    }\n    .tippy-content{\n      padding:0 !important;\n      width: 220px !important;\n    }\n  }\n}\n\n.city-selector {\n  .dropdown-selector {\n    height: 44px !important;\n    padding: 12px !important;\n  }\n}\n\n.navbar-button {\n  height: 44px !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 16.1px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
